import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a7102598"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  style: {
    "border": "1px solid #ddd",
    "width": "100%",
    "border-radius": "5px"
  }
};
import { ref, watch } from 'vue';
import { getPermissionMenuList } from '@/api/user';
import { findAllModuleConfigMenu } from '@/api/authModule';
import { treeToList } from '@/utils/flatTree';
export default {
  __name: 'PermissionMenu',
  props: {
    configId: {
      type: String
    }
  },
  emits: ['update'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const defaultProps = {
      children: 'childHisMenus',
      label: 'name'
    };

    // 所有权限
    const allPermission = ref([]);
    const getPermissionList = async () => {
      const res = await getPermissionMenuList();
      allPermission.value = res;
    };
    getPermissionList();
    const checkedKeys = ref([]);
    // 获取当前用户角色的权限

    const loading = ref(false);
    const getRolePermission = async () => {
      loading.value = true;
      if (!props.configId) {
        treeRef.value.setCheckedKeys([]);
        loading.value = false;
        return;
      }
      const res = await findAllModuleConfigMenu({
        id: props.configId
      });
      console.log('res:', res);
      checkedKeys.value = res;
      const arr = checkedKeys.value.map(item => {
        return item === null || item === void 0 ? void 0 : item.menuId;
      });
      treeRef.value.setCheckedKeys(arr);
      loading.value = false;
    };
    watch(() => props.configId, val => {
      setTimeout(() => {
        filterText.value = '';
        getRolePermission();
      });
    }, {
      immediate: true
    });
    const handleCheck = (e, flag) => {
      const checks = treeRef.value.getCheckedKeys();
      if (flag) {
        treeRef.value.setCheckedKeys([e.id, ...checks]);
        if (e !== null && e !== void 0 && e.parentId) {
          treeRef.value.setCheckedKeys([e === null || e === void 0 ? void 0 : e.parentId, ...checks]);
        }
      } else {
        let arr = checks.filter(item => item.id !== e.id);
        if (e !== null && e !== void 0 && e.childHisMenus.length) {
          arr = arr.filter(item => !e.childHisMenus.find(v => v.id === item));
        }
        treeRef.value.setCheckedKeys(arr);
      }
      const arr = [...treeRef.value.getCheckedNodes()];
      emits('update', arr);
    };

    // tree 节点
    const treeRef = ref(null);
    const isExpand = ref(false);
    const isAllCheck = ref(false);
    const switchChange = () => {
      const treeList = allPermission.value;
      for (let i = 0; i < treeList.length; i++) {
        treeRef.value.store.nodesMap[treeList[i].id].expanded = isExpand.value;
      }
    };
    watch(isAllCheck, val => {
      if (val) {
        console.log(allPermission.value, 'allPermission.value');
        treeRef.value.setCheckedKeys(treeToList(allPermission.value).map(item => item.id));
      } else {
        treeRef.value.setCheckedKeys([]);
      }
    });
    const filterText = ref('');
    watch(filterText, val => {
      treeRef.value.filter(val);
    });
    const filterNode = (value, data) => {
      console.log(value, data);
      if (!value) return true;
      return data.remark.includes(value);
    };
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_tree = _resolveComponent("el-tree");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
        modelValue: isExpand.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isExpand.value = $event),
        style: {
          "line-height": "0"
        },
        onChange: switchChange
      }, {
        default: _withCtx(() => [_createTextVNode(" 展开/折叠 ")]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
        modelValue: isAllCheck.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => isAllCheck.value = $event),
        style: {
          "line-height": "0"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" 全选/全不选 ")]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [_withDirectives(_createVNode(_component_el_tree, {
        ref_key: "treeRef",
        ref: treeRef,
        data: allPermission.value,
        "show-checkbox": "",
        "node-key": "id",
        props: defaultProps,
        "highlight-current": "",
        onCheckChange: handleCheck,
        "check-strictly": "",
        "filter-node-method": filterNode
      }, null, 8, ["data"]), [[_directive_loading, loading.value]])])]);
    };
  }
};